import { EVENTS } from "../global/constants";

export class Subject {
    constructor() {
        this.observers = [];
    }

    addObserver(obs) {
        this.observers.push(obs);
    }
    
    removeObserver(obs) {
        const removeIndex = this.observers.indexOf(obs);
        if ( removeIndex !== -1 ) {
            this.observers.splice(removeIndex, 1);
        }
    }

    notifyObserver(event) {
        this.observers.forEach( o => o.update(event) );
    }
}

export class SettingSubject extends Subject {
    constructor() {
        super();
    }

    boardOrderChange() {
        this.notifyObserver({
            name: EVENTS.update,
            value: EVENTS.boardOrder,
        })
    }

    boardVisibilityChange(hidden=false, boardDetails = {}) {
        const event = {
            name: EVENTS.update,
            value: EVENTS.boardVisibility,
            hidden: hidden,
        }

        if ( boardDetails !== {} ) {
            event.boardDetails = boardDetails;
        } 
        this.notifyObserver(event);
    }

    boardCreation(boardDetails = {}) {
        const event = {
            name: EVENTS.update,
            value: EVENTS.boardNew
        }
        this.notifyObserver(event);
    }

    boardEdit() {
        console.log('board edit');
        const event = {
            name: EVENTS.update,
            value: EVENTS.boardEdit,
        }
        this.notifyObserver(event);
    }
}

export class BoardsSubject extends Subject {
    constructor() {
        super();
    }

    runBoardsReload() {
        this.notifyObserver({
            name: EVENTS.update,
            value: EVENTS.reload,
        })
    }
}

export class TodoSubject extends Subject {
    constructor() {
        super();
    }

    runReload() {
        this.notifyObserver({
            name: EVENTS.update,
            value: EVENTS.reload,
        });
    }

    orderChange() {
        this.notifyObserver({
            name: EVENTS.update,
            value: EVENTS.toDoOrder
        });
    }

    runEvent(eventType=EVENTS.reload) {
        this.notifyObserver({
            name: EVENTS.update,
            value: eventType
        })
    }
}

export class TasksSubject extends Subject {
    constructor() {
        super();
    }

    runReload() {
        this.notifyObserver({
            name: EVENTS.update,
            value: EVENTS.reload
        });
    }
}

export class ControllerSubject extends Subject {
    constructor() {
        super();
    }

    runReload() {
        this.notifyObserver({
            name: EVENTS.update,
            value: EVENTS.reload
        });
    }
}